
import { ref, onMounted, reactive, defineComponent } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import RequirementForm from '../forms/RequirementForm.vue'

export default defineComponent({
  components: {
    DataTable,
    RequirementForm,
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const tabelParams = reactive({
      endpoint: '/talent/v1/requirements',
      headerTitle: 'Tambah Jenis Persyaratan',
      buttonTitle: '',
      editTitle: 'Edit',
      deleteTitle: 'Hapus',
      showDetailTitle: 'Detail',
      confirmDialogDelete: {
        title: 'Hapus Jenis Persyaratan?',
        subTitle: 'Data jenis persyaratan tersebut akan dihapus dalam sistem. Yakin hapus jenis persyaratan?',
        btnSubmitTitle: 'Hapus Jenis Persyaratan',
      },
      columnsTable: [
        {
          field: 'name',
          headerName: 'Persyaratan',
          searchable: true,
          fieldSearch: 'name',
          isRender: false
        },
        {
          field: 'dataType',
          headerName: 'Parameter',
          searchable: true,
          fieldSearch: 'dataType',
          isRender: true
        },
        {
          field: 'description',
          headerName: 'Keterangan',
          searchable: true,
          fieldSearch: 'description',
          isRender: false
        },
      ]
    })

    const successDeleteToast = {
      summary: 'Jenis Persyaratan berhasil dihapus',
      detail: 'Data Jenis Persyaratan berhasil diahapus dari dalam sistem'
    }

    const onShowStatus = (data: any) => {
      // console.log('store', store.state)
      router.push({
        name: 'master-position-detail',
        params: {
          // id: encryptDecriptMethods.encrypt(data)
        }
      })
    }

    const onShowDetailAct = (data: any) => {
      // console.log('store', store.state)
      router.push({
        name: 'master-position-detail',
        params: {
          id: encryptDecriptMethods.encrypt(data)
        }
      })
    }
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      tabelParams,
      successDeleteToast,
      onShowDetailAct,
      onShowStatus,
    }
  }
})
